export default __webpack_public_path__ + "static/media/marker.27d90041.svg";